import { useDisclosure, usePaginatedFilters } from 'further-ui/hooks';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import api from 'lib/trpcClient';
import { SortOrder } from 'further-types/utils';

export default function useListDocuments(
  pageId: string,
  vehicleId: string | null,
) {
  const { filters, handleChangeFilters, pagination } = usePaginatedFilters(
    pageId,
    {
      defaultFilters: {
        search: '',
      },
      defaultOrder: {
        orderBy: 'documentName',
        order: SortOrder.Asc,
      },
      orderByOptions: ['documentName'],
    },
  );

  const { data, isFetching } = api.vehicleSigningDocument.list.useQuery(
    { vehicleId: vehicleId ?? '' },
    { enabled: !!vehicleId },
  );

  const filteredDocuments = data?.results.filter((document) =>
    document.documentName.toLowerCase().includes(filters.search.toLowerCase()),
  );

  const addDocumentDisclosure = useDisclosure();
  const deleteDocumentDisclosure = useDisclosure<{ id: string }>();
  const editSignatureLocationsDisclosure = useDisclosure<{ id: string }>();

  const removeSigningDocument = api.vehicleSigningDocument.remove.useMutation(
    useHandleTrpcMutation()({
      successMessage: 'Document removed successfully.',
      onSuccess: () => {
        deleteDocumentDisclosure.onClose();
      },
    }),
  );

  const handleRemoveSigningDocument = () => {
    removeSigningDocument.mutate({
      vehicleSigningDocumentId: deleteDocumentDisclosure.actionProps.id,
      vehicleId: vehicleId ?? '',
    });
  };

  const { mutate: runPostEditTemplateChecks } =
    api.vehicleSigningDocument.postTemplateEditChecks.useMutation(
      useHandleTrpcMutation()({}),
    );

  return {
    isFetching,
    documents: filteredDocuments ?? [],
    filters,
    handleChangeFilters,
    pagination,
    handleRemoveSigningDocument,
    isRemovingSigningDocument: removeSigningDocument.isPending,
    deleteDocumentDisclosure,
    addDocumentDisclosure,
    editSignatureLocationsDisclosure,
    runPostEditTemplateChecks,
  };
}
